module.exports = __webpack_public_path__ + "static/media/carIMg.3c8057a6.png";